import { QueryKeys } from "@/constants";
import { queryClient } from "@/hooks/use-query-client";
import { lowerCaseComparison } from "./string-util";

export const PRODUCT_NAME = {
  BLUEWATER: "Blue Water",
  ZCONNECT: "zConnect",
  VOYAGER: "Voyager",
  EDISON: "Edison",
  COBALT: "JoinHealth",
  BOON: "Boon",
  LEADING: "My LEA",
  PBA: "PBA",
  VITORI: "MyVitori",
  // DECENT: "Decent", BRANDING APP SO USE ZCONNECT
  COOK: "Cook Medical",
  PBS: "Professional Benefit Services, Inc.",
  JPFARLEY: "J.P. Farley Connect",
} as const;

export enum CLIENT_NAME {
  COBALT = "COBALT",
  BOON = "BOONCHAPMAN",
}

export enum THIRD_PARTY_INTEGRATION {
  EBIX = "EBIX",
  WEX = "WEX",
}

export enum EBIX_URL {
  // For now both forget password and register link are same
  BASE = "https://ebixhub.ebix.com/sso/client/ClientLogin.aspx?client=",
  // FORGET_PASSWORD = 'https://ebixhub.ebix.com/sso/client/ClientLogin.aspx?client=bm',
  // REGISTER = 'https://ebixhub.ebix.com/sso/client/ClientLogin.aspx?client=bm',
}

export enum PROVIDER_NETWORK_TYPE {
  RBP = "RBP", // cobalt-bba rbp
}

export function getEbixUrl(clientCode: string) {
  return `${EBIX_URL.BASE}${clientCode}`;
}

export function getGroupIdLabel(groupId: string | undefined | null) {
  if (groupId?.startsWith(CLIENT_NAME.COBALT)) return "Group Number";
  return "Group ID";
}

export function isRbpClient(memberId: string | undefined) {
  const providerNetworkTypeQuery = queryClient.getQueryData([
    QueryKeys.PROVIDER_NETWORK_TYPE,
    memberId,
  ]);

  return lowerCaseComparison(
    providerNetworkTypeQuery?.data?.networkType?.[0],
    PROVIDER_NETWORK_TYPE.RBP,
  );
}

// export function enableCoverageCertificate(groupId: string | undefined | null) {
//   return Boolean(groupId === CLIENT_NAME.BOON);
// }

// export function getClaimsTitle(groupId: string | undefined | null) {
//   if (groupId?.startsWith(CLIENT_NAME.COBALT)) return "Claims";
//   else return "Care & Claims History";
// }
